<!--快捷 历史记录-->
<template>
    <div class="id center-wrap">
        <div class="navBar cur-poi" @click="$nav.back()">
            <van-icon name="arrow-left" />
            {{ $t('等级规则') }}
        </div>
        <div class="dis-fle flex-wrap jus-bet">
            <div class="box" v-for="value in list" :key="value.id">
                <div class="boxs">
                    <van-image width="20" height="20" :src="require('@/assets/img/footer/icon15.svg')" />
                    <div style="padding: 0 6px;">{{ value.name }}</div>
                    <div v-if="value.current_level" style="color: #00f0ff;">{{ $t('当前等级') }}</div>
                </div>
                <div class="boxt">
                    <div>{{ value.require_num }}{{ $t('位好友账户总余额达到') }}{{ value.require_money }}USDT</div>
                    <div style="padding: 8px 0;">
                        {{ $t('分享好友里需要有') }} {{ value.require_level_num }} {{ $t('位') }} L{{ value.require_level }}{{
                            $t('级帐户') }}
                    </div>
                    <div v-if="value.reward_rule" class="boxtd">{{ $t('AI策略交易返还服务费用') }}: {{ $t('级') }}{{
                        value.reward_rule[1] }}%,
                        2{{ $t('级') }}{{ value.reward_rule[2] }}%,{{ value.reward_rule[3] }}{{ $t('级') }}3% </div>
                </div>

            </div>
        </div>

    </div>
</template>
<script>
import { get } from '@/http/request'
export default {
    components: {
    },
    data() {
        return {
            list: [],
        };
    },
    mounted() {
        this.getTeamRuleList()
    },
    methods: {
        async getTeamRuleList() {
            const res = await get(this.$apis.getTeamRuleList)
            if (res.code == 1) {
                this.list = res.data.list
                return
            }
        },

    },
};
</script>
<style lang="less" scoped>
.id {
    color: #fff;
    padding: 20px 0px;
    font-size: 14px;
    background-color: #000;

    .navBar {
        padding: 15px 10px;
        font-size: 18px;
        font-weight: 700;
        border-radius: 4px;
    }

    .box {
        background-color: #12141e;
        margin-top: 14px;
        border-radius: 8px;
        width: 32.7%;

        .boxs {
            padding: 15px;
            border-bottom: 1px solid #2c2d31;
            display: flex;
            align-items: center;
        }

        .boxt {
            padding: 15px;

            .boxtd {
                color: #888;
                font-size: 13px;
            }
        }
    }



}
</style>
